<div class="modal-header">
    <h4 class="modal-title">Employee All Detail</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body">
    <section>
        <div class="card">+
            <div class="card-content">
                <div class="card-body ">
                    <form (ngSubmit)="getList(listForm.getRawValue())" [formGroup]="listForm" class="full-width ">
                        <div class="form-row">
                            <div class="col-md-4 mb-1 form-group">
                                <label for="Code">Designation Code</label>
                                <input type="text" formControlName="Code" name="Code" class="form-control" id="Code"
                                    placeholder="Designation Code">
                            </div>
                            <div class="col-md-4 mb-1 form-group">
                                <label for="Name">Designation Name</label>
                                <input type="text" formControlName="Name" name="Name" class="form-control" id="Name"
                                    placeholder="Designation Name">
                            </div>
                            <div class="col-md-4 mb-1 form-group">
                                <button class="btn btn-sm btn-info mr-1 mb-1 w-85px" type="submit">
                                    <i class="ft-search mr-1"></i>Search</button>
                                <button class="btn btn-sm btn-custom ml-1 mb-1 w-85px ClearFormContent" type="button">
                                    <i class="ft-x-circle mr-1"></i>
                                    Clear</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="card">
            <div class="card-content">
                <div class="card-body ">
                    <div class="row">
                        <div class="col-12">
                            <form>
                                <div class="form-group form-inline pull-left">
                                    Show <select class="custom-select" style="width: auto" name="pageSize"
                                        [(ngModel)]="dtTableService.pageSize">

                                        <option [ngValue]="10">10</option>
                                        <option [ngValue]="25">25</option>
                                        <option [ngValue]="50">50</option>
                                        <option [ngValue]="100">100</option>
                                    </select> Pages

                                </div>
                                <div class="form-group form-inline pull-left ml-2">
                                    <div ngbDropdown #myDrop1="ngbDropdown">
                                        <button class="btn btn-outline-primary mr-1" id="dropdownMenu2"
                                            ngbDropdownToggle>Export </button>
                                        <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenu2"
                                            role="menu">
                                            <!-- <button class="dropdown-item"
                                                (click)="dtTableService.export('copy', dataSource ,'abc')">Copy</button>
                                            <button class="dropdown-item"
                                                (click)="dtTableService.export('csv', dataSource)">CSV</button>
                                            <button class="dropdown-item"
                                                (click)="dtTableService.export('pdf', dataSource)">PDF</button>
                                            <button class="dropdown-item"
                                                (click)="dtTableService.export('excel', dataSource)">Excel</button>
                                            <button class="dropdown-item"
                                                (click)="dtTableService.export('print', dataSource)">Print</button> -->
                                        </div>
                                    </div>
                                    <span class="ml-3" *ngIf="dtTableService.loading$ | async">Loading...</span>
                                </div>
                                <div class="form-group form-inline pull-right">
                                    Search: <input class="form-control ml-2" type="text" name="searchTerm"
                                        [(ngModel)]="dtTableService.searchTerm" />
                                    <!-- <span class="ml-3" *ngIf="dtTableService.loading$ | async">Loading...</span> -->
                                </div>

                                <div class="table-responsive" id="htmlData" #htmlData>
                                    <table class="table table-striped" id="exceltable" #exceltable>
                                        <thead>
                                            <tr>
                                                <th scope="col"></th>
                                                <th scope="col" sortable="Code" (sort)="onSort($event)">Designation
                                                    Code<i class="fa fa-sort"></i></th>
                                                <th scope="col" sortable="Title" (sort)="onSort($event)">Designation
                                                    Name<i class="fa fa-sort"></i></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of dataSources$ | async;let i = index">
                                                <th scope="row"><a (click)="selectDesignation(item)">select</a></th>
                                                <td>
                                                    <ngb-highlight [result]="item.Code"
                                                        [term]="dtTableService.searchTerm"></ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.Title"
                                                        [term]="dtTableService.searchTerm"></ngb-highlight>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-flex justify-content-between p-2 pull-right">
                                    <ngb-pagination [collectionSize]="total$ | async" [maxSize]="3" [rotate]="true"
                                        [(page)]="dtTableService.page" [pageSize]="dtTableService.pageSize">
                                        <ng-template ngbPaginationPrevious>Prev</ng-template>
                                        <ng-template ngbPaginationNext>Next</ng-template>
                                    </ngb-pagination>

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>